import React from 'react';
import { AlertCircle, CheckCircle, Info, AlertTriangle, X } from 'lucide-react';

const AlertMessage = ({
  type = 'info',
  // "= undefined" makes the prop optional for TypeScript callers.
  message = undefined,
  title = undefined,
  dismissible = false,
  onDismiss = undefined,
  className = '',
  children,
  ...props
}) => {
  if (!message && !children) return null;

  const config = {
    success: {
      containerClass: 'bg-green-50 border-green-200 text-green-800',
      iconClass: 'text-green-400',
      icon: CheckCircle
    },
    error: {
      containerClass: 'bg-red-50 border-red-200 text-red-800',
      iconClass: 'text-red-400',
      icon: AlertCircle
    },
    warning: {
      containerClass: 'bg-yellow-50 border-yellow-200 text-yellow-800',
      iconClass: 'text-yellow-400',
      icon: AlertTriangle
    },
    info: {
      containerClass: 'bg-blue-50 border-blue-200 text-blue-800',
      iconClass: 'text-blue-400',
      icon: Info
    }
  };

  const { containerClass, iconClass, icon: Icon } = config[type] || config.info;

  return (
    <div 
      className={`mb-6 p-4 border rounded-lg ${containerClass} ${className}`}
      {...props}
    >
      <div className="flex items-start">
        <Icon className={`h-5 w-5 ${iconClass} mr-3 mt-0.5 flex-shrink-0`} />
        <div className="flex-1 min-w-0">
          {title && (
            <h4 className="text-sm font-medium mb-1">{title}</h4>
          )}
          {message && (
            <p className="text-sm">{message}</p>
          )}
          {children}
        </div>
        {dismissible && onDismiss && (
          <button
            type="button"
            className={`ml-3 flex-shrink-0 ${iconClass} hover:opacity-75`}
            onClick={onDismiss}
          >
            <X className="h-4 w-4" />
          </button>
        )}
      </div>
    </div>
  );
};

export default AlertMessage;
